export const CheckIcon = () => {
    return (
        <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_23_1415)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1858 1.63747C16.5417 0.81642 15.3539 0.673041 14.5328 1.31722L5.88038 8.10578L3.75974 4.43272C3.23794 3.52894 2.08229 3.21929 1.17851 3.74108C0.274731 4.26288 -0.0349248 5.41854 0.486871 6.32231L3.51022 11.5589C4.00586 12.4174 5.0734 12.7398 5.95375 12.3228C6.36924 12.3277 6.78914 12.1963 7.1415 11.9199L16.8656 4.29049C17.6866 3.64631 17.83 2.45851 17.1858 1.63747Z" fill="#182F4C" />
            </g>
            <defs>
                <filter id="filter0_d_23_1415" x="0.233398" y="0.914185" width="17.3555" height="11.5898" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_23_1415" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_23_1415" result="shape" />
                </filter>
            </defs>
        </svg>

    )
}